import React from 'react'
import ForcedNotificationWrapper from './ForcedNotificationWrapper'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import { Link } from '@morningtrain/react-navigation'

export default function ForcedChecklists ({ checklists }) {
  return (
    <ForcedNotificationWrapper>
      <UI.CardHeader>
        <UI.PrimaryHeading>
          <Translation name='tablet.notify.unfinished_open_checklist.title' />
        </UI.PrimaryHeading>
      </UI.CardHeader>
      <div className='w-full flex flex-col pb-8'>
        <UI.SpaceBetween>
          <UI.Text>
            <Translation name='tablet.notify.unfinished_open_checklist.message' />
          </UI.Text>
          <Link disableRouting route='app.checklists'>
            <UI.Button>
              <Translation name='tablet.notify.unfinished_open_checklist.view_checklists' />
            </UI.Button>
          </Link>
        </UI.SpaceBetween>
        {/* checklists.map(checklist => {
          return (
            <UI.SpaceBetween key={checklist.id}>
              <div>
                <UI.Text>
                  {checklist.name}
                </UI.Text>
              </div>
              <Link disableRouting route='app.view_checklist' parameters={{ checklist: checklist.id }}>
                <UI.Button>
                  <Translation name='tablet.notify.unfinished_open_checklist.view_checklist' />
                </UI.Button>
              </Link>
            </UI.SpaceBetween>
          )
        }) */}
      </div>
    </ForcedNotificationWrapper>
  )
}
